import {
    ListItemText,
    Menu,
    MenuItem,
    ListItemButton,
    Box,
    IconButton
} from "@mui/material";
import favoriteDiagnosis from "dto/favoriteDiagnosis.dto";
import { Fragment, useState } from "react";
import { FieldArrayWithId } from "react-hook-form";
import { useEncounter } from "pages/encounter/encounter.provider";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { isEmpty } from "lodash";
export type FavItem = {
    field: FieldArrayWithId<
        {
            favoriteList: favoriteDiagnosis[];
        },
        "favoriteList",
        "id"
    >;
    updateIncrement: () => void;
    remove: () => void;
    swapUp: () => void;
    swapDown: () => void;
    disabledUp?: boolean;
    disabledDown?: boolean;
};

const FavItem = (props: FavItem) => {
    const {
        field,
        remove,
        updateIncrement,
        swapDown,
        swapUp,
        disabledDown,
        disabledUp
    } = props;

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [mouseX, setMouseX] = useState<number>(0);
    const [mouseY, setMouseY] = useState<number>(0);
    const { insertOrReplaceDiagnosis, allDiagnosis } = useEncounter();

    const open = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOnClickDelete = () => {
        remove();
        handleClose();
    };

    return (
        <Fragment key={field.id}>
            <Box display="flex" justifyContent="center" alignItems="center">
                <ListItemButton
                    onClick={(e) => {
                        if (
                            allDiagnosis.length === 1 &&
                            isEmpty(allDiagnosis[0].term)
                        ) {
                            insertOrReplaceDiagnosis("principal", field);
                        } else {
                            setAnchorEl(e.currentTarget);
                            setMouseX(e.clientX);
                            setMouseY(e.clientY);
                        }
                    }}
                >
                    <ListItemText
                        primary={`${field?.term ?? ""} (${(field?.icd10 ?? [])
                            .map((i) => i.code)
                            .join(",")})`}
                    ></ListItemText>
                </ListItemButton>
                <IconButton
                    tabIndex={-1}
                    sx={{ padding: 0 }}
                    size="small"
                    color="success"
                    onClick={swapUp}
                    disabled={disabledUp}
                >
                    <ArrowUpwardIcon fontSize="inherit" />
                </IconButton>
                <IconButton
                    tabIndex={-1}
                    sx={{ padding: 0 }}
                    size="small"
                    color="warning"
                    onClick={swapDown}
                    disabled={disabledDown}
                >
                    <ArrowDownwardIcon fontSize="inherit" />
                </IconButton>
            </Box>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                anchorPosition={{
                    left: mouseX!,
                    top: mouseY!
                }}
                anchorReference="anchorPosition"
            >
                <MenuItem
                    onClick={() => {
                        insertOrReplaceDiagnosis("principal", field);
                        updateIncrement();
                        handleClose();
                    }}
                >
                    <ListItemText>Replace On Principal Diagnosis</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        insertOrReplaceDiagnosis("comorbidity", field);
                        handleClose();
                    }}
                >
                    <ListItemText>Insert Into Comorbidity</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        insertOrReplaceDiagnosis("complication", field);
                        updateIncrement();
                        handleClose();
                    }}
                >
                    <ListItemText>Insert Into Complication</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        insertOrReplaceDiagnosis("other", field);
                        updateIncrement();
                        handleClose();
                    }}
                >
                    <ListItemText>Insert Into Other</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        insertOrReplaceDiagnosis("externalCause", field);
                        updateIncrement();
                        handleClose();
                    }}
                >
                    <ListItemText>Insert Into External Cause</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={handleOnClickDelete}
                    sx={{
                        color: (theme) => theme.palette.error.main
                    }}
                >
                    <ListItemText>Delete</ListItemText>
                </MenuItem>
            </Menu>
        </Fragment>
    );
};

export default FavItem;
